export default {
  ROBOTO_THIN: "Roboto-Thin",
  ROBOTO_LIGHT: "Roboto-Light",
  ROBOTO_REGULAR: "Roboto-Regular",
  ROBOTO_MEDIUM: "Roboto-Medium",
  ROBOTO_BOLD: "Roboto-Bold",
  ROBOTO_BLACK: "Roboto-Black",
};
